export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-monitor-45126b413cf2314ecbc46cd587303827.svg";